<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wYn3j0/tc-custom/9781782111948.jpg?1734578124535" alt="This image is the cover for the book Walking Wounded"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Walking Wounded
      </h1>
      <p class="bookDescription body article font2">
        <b>These poignant short stories about the quiet yearnings of ordinary lives form “a sad, brilliant, joyful tribute to the dreams that never make it” (<i>Sunday Express</i>).</b><br/><br/> From a recipient of a Whitbread Award, a Faber Memorial Prize, and other literary honors—who has been called “one of Scotland's finest writers” (<i>Independent</i>)—this is a collection of stories about the casualties of social and emotional struggle, the people who defy defeat with humor, resilience, and a persistent faith in their unfulfilled dreams. Whether widows or prisoners or argumentative elderly spouses, they are all the walking wounded—and they all have the power to inspire both laughter and empathy.<br/><br/> “As a stylist Mr. McIlvanney leaves most of the competition far behind.” —<i>The New York Times Book Review</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        William McIlvanney
      </h2>
      
      <p class="authorDescription body article">William McIlvanney's first novel, Remedy is None, won the Geoffrey Faber Memorial Prize and with Docherty he won the Whitbread Award for Fiction. Laidlaw and The Papers of Tony Veitch both gained Silver Daggers from the Crime Writers' Association. Strange Loyalties, the third in the Detective Laidlaw trilogy, won the Glasgow Herald's People's Prize. He died in December 2015.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Hodder and Stoughton Ltd
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05f87188